import { render, staticRenderFns } from "./case-lists.vue?vue&type=template&id=6379fd82&scoped=true"
import script from "./case-lists.vue?vue&type=script&lang=js"
export * from "./case-lists.vue?vue&type=script&lang=js"
import style0 from "./case-lists.vue?vue&type=style&index=0&id=6379fd82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6379fd82",
  null
  
)

export default component.exports